<template>
  <div v-if="content.listeIdProduit" :class="jel_getClassObject(content)" class="w-100">
    <CarteListe :content="getContentCarteListe()">
      <template #element="{ itemElement, elementPremiereLigne }">
        <MediaImageLogoProduitCasinoLarge
          v-if="content.nbColonne == 1"
          :content="{
            ...getItemElement(itemElement),
            isListeHorizontale: content.isListeHorizontale,
            formatCarte: content.formatCarte,
          }"
          class="h-100 d-flex align-items-center"
        >
        </MediaImageLogoProduitCasinoLarge>
        <MediaImageLogoProduitCasino3x4
          v-else-if="content.nbColonne == 2"
          :content="{
            ...getItemElement(itemElement),
            nbColonne: content.nbColonne,
            elementPremiereLigne: elementPremiereLigne,
          }"
        >
        </MediaImageLogoProduitCasino3x4>
      </template>
    </CarteListe>
  </div>
</template>

<script>
import CarteListe from '@/components/base/carte/CarteListe';
import MediaImageLogoProduitCasinoLarge from '@/components/casino/media/image/MediaImageLogoProduitCasinoLarge';
import MediaImageLogoProduitCasino3x4 from '@/components/casino/media/image/MediaImageLogoProduitCasino3x4';

export default {
  name: 'CarteListeProduitCasino',
  components: {
    CarteListe,
    MediaImageLogoProduitCasinoLarge,
    MediaImageLogoProduitCasino3x4,
  },
  props: {
    content: { type: Object, required: true },
  },
  methods: {
    getContentCarteListe() {
      return {
        listeElement: this.content.listeIdProduit,
        nbColonne: this.content.nbColonne,
        titre: this.content.titre,
        lien: this.content.lien,
        formatCarte: this.content.formatCarte,
        isListeHorizontale: this.content.isListeHorizontale,
        nbMaxProduitsAffiches: this.content.nbMaxProduitsAffiches,
        idProduitCollection: this.content.idProduitCollection,
        nbLigne: this.content.nbLigne,
      };
    },
    getItemElement(itemElement) {
      return typeof itemElement == 'string' ? { idProduit: itemElement } : { produit: itemElement };
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: black !important;
}

.vhl-item > div {
  display: flex;
  > div {
    display: flex;
    &::v-deep > div {
      display: flex;
    }
  }
}
</style>
